import { SET_USERNAME} from './actionTypes';

export const setUserName = (username) => {
    return {
        type: SET_USERNAME,
        payload: {
            username: username
        }
    };
};